import { MayBe, TFasterPayoutSource } from './types';

type TFasterPayoutSourcePayload = {
  source?: MayBe<string>;
  Source?: MayBe<string>;
  createdBy?: MayBe<string>;
};

export const normalizeFasterPayoutSource = (
  payout: TFasterPayoutSourcePayload,
): TFasterPayoutSource | undefined => {
  const rawSource = (payout.source ?? payout.Source)?.trim().toLowerCase();
  if (rawSource === 'api' || rawSource === 'mc') {
    return rawSource;
  }

  const createdBy = payout.createdBy?.toLowerCase() ?? '';
  if (
    createdBy.includes('source:fpapi') ||
    createdBy.includes('source:ifpapi') ||
    createdBy.includes('source:api')
  ) {
    return 'api';
  }
  if (createdBy.includes('source:fpmc') || createdBy.includes('source:mc')) {
    return 'mc';
  }

  return undefined;
};
